module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agreePublic":"I accept the ","offer":"terms and conditions","confirm":"Confirm payment"}}')
  delete Component.options._Ctor
}
